import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { IOutcomeDefinition } from '@innerhive-internal/innerhive-common';

const useStyles = createUseStyles({
    summaries: {
        display: 'flex',
        flexDirection: 'column' as const,
        gap: 8,
        margin: 0
    },

    title: {
        fontWeight: 600
    },

    summary: {
        margin: 0
    }
});

export const OutcomeSummaries: FC<{ definitions: IOutcomeDefinition[] }> = ({ definitions }) => {
    const classes = useStyles();

    return (
        <dl className={classes.summaries} data-id="outcome-summaries">
            {definitions.map(definition => (
                <div key={definition.title}>
                    <dt className={classes.title}>{definition.title}</dt>
                    <dd className={classes.summary}>{definition.summary}</dd>
                </div>
            ))}
        </dl>
    );
};
